import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { faX, fasShuffle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
import { faShuffle } from '@fortawesome/free-solid-svg-icons/index';


export class ItemLookupInfo extends Component { 

    constructor(props) {
        super(props);
    }

    render() {
        console.log("SELECTED VIEW", this.props.selectedView);
        const moveItemFunction = this.props.moveItem;
        const removeItemFunction = this.props.removeItem;
        const lookupSiblingFunction = this.props.lookupSibling;
        let sublocationsByLocation = {};
        this.props.sublocationInfo.forEach(sublocation => {
            if(!sublocationsByLocation[sublocation.location]) {
                sublocationsByLocation[sublocation.location] = [];
            }
            sublocationsByLocation[sublocation.location].push(sublocation);
        });
        return (
            <div className="scrollable-list item-lookup-info">
                <div className="item-lookup-container">
                    {
                        this.props.imageURLs[0]
                        &&
                        <img
                            src={this.props.imageURLs[0]}
                            onClick={(e) => this.props.viewImage(e, this.props.itemName, this.props.imageURLs[0])}
                            alt={this.props.itemName}
                            className="item-image"
                        />
                    }
                    <div className="item-info">
                        {this.props.itemInfo.map((itemAspect, index) => (
                            <h3 key={index}>
                                <b>{itemAspect.displayName}</b>: {itemAspect.value}
                            </h3>
                        ))}
                    </div>
                </div>
                <br />
                <div className="view-toggle">
                    <label>
                        <select value={this.props.selectedView} onChange={this.props.handleViewChange}>
                            <option value="stock">Stock Info</option>
                            {this.props.sublocationInfo.length > 0 && <option value="sublocations">Sublocation Info</option>}
                            {this.props.siblingsInfo.length > 0 && <option value="siblings">Other Options</option>}
                        </select>
                    </label>
                </div>
                {
                    this.props.selectedView === "stock" &&
                    (
                        this.props.onHandQty > 0 ?
                        <>
                            <br />
                            <table className="lookup-item-table table" aria-labelledby="tabelLabel">
                                <thead>
                                    <tr>
                                        <th>Location</th>
                                        <th>Bin</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.inventoryInfo.map(inventoryAspect => {
                                        return (
                                            <tr key={inventoryAspect.location}>
                                                <td>{inventoryAspect.location}</td>
                                                <td>{inventoryAspect.bin}</td>
                                                <td>{inventoryAspect.quantityAvailable}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                         </>
                        :
                        <h3>No Qty On Hand</h3>
                    )
                }
                {
                    this.props.selectedView === "sublocations" &&
                    (
                        this.props.sublocationInfo.length > 0 ?
                            Object.keys(sublocationsByLocation).map(location => (
                                <>
                                    <br />
                                    <h3>{location}</h3>
                                    <table className="sublocation-table table" aria-labelledby="tabelLabel">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Sublocation</th>
                                                <th>Max Quantity</th>
                                                <th>Preferred</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sublocationsByLocation[location].map(sublocation => {
                                                const sublocationInfo = {
                                                    id: sublocation.id,
                                                    name: sublocation.name,
                                                    imageURL: sublocation.imageURL,
                                                }
                                                return (
                                                    <tr key={sublocation.stkinfoid}>
                                                        <td>
                                                            <FontAwesomeIcon className="imageIcon" onClick={() => { removeItemFunction(sublocation) }} size="lg" icon={faX} color="red" />
                                                            <br />
                                                            <FontAwesomeIcon className="imageIcon" onClick={() => { moveItemFunction(sublocation) }} size="lg" icon={faShuffle} />
                                                        </td>
                                                        <td>
                                                            <Link
                                                                to={{
                                                                    pathname: "/ManageSublocations",
                                                                    state: { sublocationInfo: sublocationInfo }
                                                                }}
                                                            >
                                                                <h3>{sublocationInfo.name}</h3>
                                                            </Link>
                                                        </td>
                                                        <td>{sublocation.maxCapacity}</td>
                                                        <td>{sublocation.preferred ? 'Y' : 'N'}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </>
                            ))
                            :
                            <h3>No Sublocations</h3>
                    )
                }
                {
                    this.props.selectedView === "siblings" && this.props.siblingsInfo.length > 0
                    &&
                        <>
                            <br />
                            <table className="lookup-item-table table" aria-labelledby="tabelLabel">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.siblingsInfo.map(sibling => {
                                        return (
                                            <tr key={sibling.id} onClick={() => { lookupSiblingFunction(sibling.upccode)}}>
                                                <td>{sibling.displayname}</td>
                                                <td>{sibling.qty}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </>
                }
            </div>
        );
    }
}